// extracted by mini-css-extract-plugin
export default {"header":"FilterHeader_header__JD0gQ","searchContainer__textfield":"FilterHeader_searchContainer__textfield__ClMDZ"};